import React from "react";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import ReportTable from "./ReportTable";
import { Box, Button } from "@mui/material";

const Report = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{display:'flex', justifyContent:'space-between'}}>
        <Breadcrumbs aria-label="breadcrumb" sx={{mt:4}}>
          <Link underline="hover" color="inherit" href="/">
            Home
          </Link>
          <Typography color="text.primary">Report</Typography>
        </Breadcrumbs>
        <Button sx={{mt:4}} variant="outlined" href="/print-annual-report" target="_blank">Annual Incident Report</Button>
      </Box>
      <ReportTable />
    </Container>
  );
};

export default Report;
